import { error, finish } from '../../../modules/markets/actions/update';
import api from '../../../api';

let updates = {};

function updateMarket(dispatch, id, eventId, market) {

    if (market.betLimitsMap) {
        for(let type in market.betLimitsMap){
            for(let betLimit in market.betLimitsMap[type]){
                market.betLimitsMap[type][betLimit] = Math.round(+market.betLimitsMap[type][betLimit] * 100);
            }
        }
    }

    if (market.cashoutMarketSettings) {
        for (let value in market.cashoutMarketSettings) {
            market.cashoutMarketSettings[value] = market.cashoutMarketSettings[value] ? Math.round(market.cashoutMarketSettings[value] * 100, 2) : 0;
        }
    }

    let promise = api.patch(`/events/${eventId}/markets/${id}`, market).then(
        (response) => {
            promise.resolved = true;
            dispatch(finish(id, market, response));
        },
        (errors) => {
            promise.resolved = true;
            dispatch(error(id, errors));
        }
    );

    return promise;
}

export function request(dispatch, { id, eventId, market }) {
    let update = () => updateMarket(dispatch, id, eventId, market);

    if (updates[eventId] && !updates[eventId].resolved) {
        updates[eventId] = updates[eventId].then(update, update);
    } else {
        updates[eventId] = update();
    }
}
